import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import Colours from '../definitions/Colours';
import Sizes from '../definitions/Sizes';
import ZIndex from '../definitions/ZIndex';


const ANIMATION_CYCLE_DURATION = '800ms';

function BouncingDecimal({ zIndex = ZIndex.ELEMENTS, ...otherProps }) {
    return (
        <BouncingDecimal.Container
            zIndex={zIndex}
            data-name="spinner"
            {...otherProps}
        >
            <div className="decimalContainer">
                <div className="decimal" />
                <div className="decimalShadow" />
            </div>
        </BouncingDecimal.Container>
    );
}

BouncingDecimal.propTypes = {
    zIndex: PropTypes.oneOf(
        Object.values(ZIndex),
    ),
};

const BOUNCE_ANIMATION = keyframes`
    0% {
        transform: translateY(0%);
        animation-timing-function: ease-out;
    }
    50% {
        transform: translateY(-300%) scale(1.75);
        animation-timing-function: ease-in;
    }
    100% {
        transform: translateY(0%);
    }
`;

const COLOUR_CHANGE_ANIMATION = keyframes`
    0%{
        background-color: ${Colours.LIME};
        animation-timing-function: ease-out;
    }
    50% {
        background-color: ${Colours.BLUEBERRY};
        animation-timing-function: ease-in;
    }
    100% {
        background-color: ${Colours.LIME};
    }
`;

const SHADOW_ANIMATION = keyframes`
    0% {
        transform: scale(1);
        animation-timing-function: ease-out;
    }
    50% {
        transform: scale(2.5, 0.5);
        animation-timing-function: ease-in;
    }
    100% {
        transform: scale(1);
    }
`;

BouncingDecimal.Container = styled.div`
    max-width: ${Sizes.ICONS.S};
    max-height:${Sizes.ICONS.S};

    margin: 0 auto;

    & > .decimalContainer {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        & > .decimal {
            width: ${Sizes.ICONS.S};
            height: ${Sizes.ICONS.S};
            border-radius: 50%;

            background-color: ${Colours.LIME};

            animation:
                ${COLOUR_CHANGE_ANIMATION} ${ANIMATION_CYCLE_DURATION} infinite,
                ${BOUNCE_ANIMATION} ${ANIMATION_CYCLE_DURATION} infinite;

            z-index: ${props => props.zIndex};
        }

        & > .decimalShadow {
            width: ${Sizes.ICONS.S};
            height: ${Sizes.ICONS['3XS']};
            border-radius: 50%;

            background-color: ${Colours.STONE};
            filter: blur(5px);

            animation:
                ${SHADOW_ANIMATION} ${ANIMATION_CYCLE_DURATION} infinite;

            z-index: ${props => props.zIndex};
        }
    }
`;

export default BouncingDecimal;
